import { component } from 'picoapp'
import sal from 'sal.js'

export default component((node, ctx) => {
  //console.log('artist-item mounted')
  
  sal({
    threshold: .1,
  });

  return node => {
    //console.log('artist-item unmounted')
  }
})
